import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

const Select = styled.select`
  width: 100%;
  height: 40px;
  padding: 0 16px;
  border: 1px solid #1e2637;
  border-radius: 4px;
  background: #fff;
  font-size: 16px;
  color: #000;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #000;
  }

  &:disabled {
    background: #f5f5f5;
    color: #999;
    cursor: not-allowed;
  }
`;

export default {
  Wrapper,
  Select,
};
